document.addEventListener('DOMContentLoaded', function () {
  // expose globally
  window.applyShippingDiscount = function() {
    // Helper to get cookie value by name
    function getCookie(name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? match[2] : null;
    }

    const activeCode = (getCookie('discount_code_shipping') || '').toLowerCase();
    let activeDiscountShipping = discounts_shipping.some(d => activeCode === d.name);

    if (activeDiscountShipping) {
    console.log("[Discount Apply] Active shipping discount code:", activeCode);

    let shippingLine = document.querySelector('.price-summary .shipping_price');
    let progressBar = document.querySelector('.cart_goal .cg-wrapper');
    let totalPriceHeader = document.querySelector('#cart-header-mobile .totals_header');
    let totalPrice = document.querySelector('.line_total .bold');
    let totalPriceDesktop = document.querySelector('.totals-desktop.totals .totals__subtotal-value');
    let currency =  document.querySelector('.totals-mobile .shop-currency');
    if (shippingLine) {
      shippingLine.innerText = "FREE";
      shippingLine.style.color = "#F70093";
    }
    if (progressBar) {
      progressBar.querySelector('.cg-free-shipping-text').innerText = "🎉 Congratulations! You've unlocked FREE shipping!";
      progressBar.querySelector('.cg-progress-bar.progress-bar').style.width = "100%";
    }    
    if (totalPrice) {
      totalPrice.innerText =  currency.innerText + "" + totalPriceHeader.innerText.replace(/[^\d.,]/g, '');
    }
    if (totalPriceDesktop) {
      totalPriceDesktop.innerText =  totalPriceHeader.innerText;
    }
    }
    else {
    console.log("[Discount Apply] No valid shipping discount code found.");
    }
  }

  applyShippingDiscount();
});